import React, { useCallback, useEffect, useRef, useState } from 'react';
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import InfoUser from "../../components/Profile/InfoUser.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js"
import { config } from "../../config.js";
import { apiCheckDataAccount, apiFormUpdateAccount, apiGetBanks, apiGetRequestHistory } from "../../services/api.service.js";


import {
  Box,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal } = location.state || {};

  // mô tả file upload và số ảnh tối thiểu theo mục thông tin khách đang chọn (setup ở admin)
  const uploadSetting = webSetting?.upload_descriptions || {};
  const uploadConfig = uploadSetting.by_update_type?.[typeModal] || {};
  const uploadDescriptions = [];
  (uploadConfig.keys || []).forEach((key) => {
    const item = (uploadSetting.items || []).find((item) => item.key === key);
    if (item?.content) uploadDescriptions.push(item.content);
  });
  // chưa setup số ảnh tối thiểu thì bằng số mô tả ảnh admin yêu cầu (tối thiểu 1)
  const minFiles = uploadConfig.min_files ?? (uploadDescriptions.length || 1);

  // nút xác nhận hoàn thành không cần xác thực email / SĐT
  const canAutoConfirm = typeModal === "birthday" || (
    typeModal === "forget_password" && !data?.email && !data?.phone_number && !data?.bank_number
  );

  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  // yêu cầu vừa gửi + theo dõi trạng thái xử lý
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingChecks, setPollingChecks] = useState(0);
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");
  const initialStatusCheckedCodeRef = useRef("");
  const [banks, setBanks] = useState([]); // danh sách ngân hàng cho khách chọn
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_type_change: "",
    bank_code: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeBank = {
    title_change_bank: "THAY ĐỔI THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const desBankNew = {
    title_change_bank: "THÊM THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Ngân Hàng Mới",
  };
  const desBankRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Cần Xóa",
    bank_number: "Số Tài Khoản Cần Xóa",
  };
  const [desChangeBank, setDesChangeBank] = useState(originalDesChangeBank);
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_code: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });


  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });

  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    if (name === "email") {
      value = value.toLowerCase();
    }
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };

  const inputDataUpdate = (event) => {
    const { name, value } = event.target;
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
    if (name === "bank_type_change") {
      switch (value) {
        case "Thêm số tài khoản": setDesChangeBank(desBankNew)
          break;
        case "Xóa số tài khoản": setDesChangeBank(desBankRemove)
          break;
        case "Đổi số tài khoản": setDesChangeBank(originalDesChangeBank)
          break;
        default: setDesChangeBank(originalDesChangeBank)
      }
    }
  };

  useEffect(() => {
    const fetchBanks = async () => {
      setBanks(await apiGetBanks());
    };
    fetchBanks();
  }, []);

  // chọn ngân hàng: lưu mã ngân hàng (bank_code) và tên ngân hàng (bank_name)
  const selectBankCheck = (event) => {
    const bank = banks.find((item) => item.code === event.target.value);
    setDataCheck({
      ...dataCheck,
      bank_code: bank ? bank.code : "",
      bank_name: bank ? bank.name : "",
    });
  };

  const selectBankUpdate = (event) => {
    const bank = banks.find((item) => item.code === event.target.value);
    setDataUpdate({
      ...dataUpdate,
      bank_code: bank ? bank.code : "",
      bank_name: bank ? bank.name : "",
    });
  };

  // cập nhật trạng thái yêu cầu vừa gửi theo dữ liệu tra cứu mới nhất
  const mergeRequestStatus = useCallback((request) => {
    setSubmittedRequest((currentRequest) => currentRequest ? {
      ...currentRequest,
      ...request,
      request_code: request.request_code || currentRequest.request_code,
      send_type: request.send_type || currentRequest.send_type,
      update_type: request.update_type || currentRequest.update_type,
    } : request);
  }, []);

  // kiểm tra trạng thái ngay khi popup cuối vừa mở
  useEffect(() => {
    const requestCode = submittedRequest?.request_code;
    if (!openConfirm || !requestCode || initialStatusCheckedCodeRef.current === requestCode) return undefined;
    initialStatusCheckedCodeRef.current = requestCode;
    let isActive = true;
    const checkInitialStatus = async () => {
      const result = await apiGetRequestHistory(userName, requestCode);
      if (!isActive) return;
      if (result?.code === 200 && result?.data?.request) {
        mergeRequestStatus(result.data.request);
        setRequestRefreshMessage("");
      } else {
        setRequestRefreshMessage("Chưa thể cập nhật trạng thái. Hệ thống sẽ tự động kiểm tra lại sau 30 giây.");
      }
    };
    checkInitialStatus();
    return () => {
      isActive = false;
    };
  }, [mergeRequestStatus, openConfirm, submittedRequest?.request_code, userName]);

  // tự động kiểm tra trạng thái 30s / lần, tối đa 15 lần
  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process" || pollingChecks >= 15) return undefined;
    const intervalId = setInterval(async () => {
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      setPollingChecks((count) => count + 1);
      if (result?.code === 200 && result?.data?.request) {
        mergeRequestStatus(result.data.request);
        setRequestRefreshMessage("");
      }
    }, 30 * 1000);
    return () => clearInterval(intervalId);
  }, [mergeRequestStatus, openConfirm, submittedRequest?.request_code, submittedRequest?.status, pollingChecks, userName]);

  const refreshSubmittedRequest = async () => {
    if (isRefreshingRequest || !submittedRequest?.request_code) return;
    setIsRefreshingRequest(true);
    setRequestRefreshMessage("");
    const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
    if (result?.code === 200 && result?.data?.request) {
      mergeRequestStatus(result.data.request);
      setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}`);
    } else {
      setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
    }
    setIsRefreshingRequest(false);
  };

  const copySubmittedRequestCode = async () => {
    try {
      await navigator.clipboard.writeText(submittedRequest?.request_code || "");
      setRequestRefreshMessage(`Đã sao chép: ${submittedRequest?.request_code}`);
    } catch (error) {
      setRequestRefreshMessage("Không thể sao chép mã yêu cầu.");
    }
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal)
  }, [typeModal]);

  // sendType: phương thức xác thực khách chọn, chỉ kiểm tra email / SĐT theo phương thức đó
  // checkData: thông tin cũ khách nhập (truyền vào khi vừa nhập email / SĐT ở popup, state chưa kịp cập nhật)
  const validateForm = (sendType = "", checkData = dataCheck) => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!checkData.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number
    if (sendType === "phone_number" && data.phone_number) {
      if (!checkData.phone_number) {
        formIsValid = false;
        errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
      } else if (!/^\d{10}$/.test(checkData.phone_number)) {
        formIsValid = false;
        errors.phone_number = 'Số Điện Thoại không hợp lệ';
      }
    }

    // Kiểm tra trường email
    if ((sendType === "mail" || sendType === "email") && data.email) {
      if (!checkData.email) {
        formIsValid = false;
        errors.email = 'Vui lòng nhập Email';
      } else if (!/\S+@\S+\.\S+/.test(checkData.email)) {
        formIsValid = false;
        errors.email = 'Email không hợp lệ';
      }
    }

    // Kiểm tra trường bank_name
    if (!checkData.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng chọn Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!checkData.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }
    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
        if (!dataUpdate.name) {
          formIsValid = false;
          errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
        } else {
          contentUpdate = dataUpdate.name;
        }
        break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = `Vui lòng chọn ${desChangeBank.bank_name.replace("Tên ", "")}`;
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = `Vui lòng nhập ${desChangeBank.bank_number}`;
        } else {
          contentUpdate = (dataUpdate.bank_type_change + " - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name)
        }
        break;
      case "birthday": // Kiểm tra trường birth day
        if (!dataUpdate.birth_day) {
          formIsValid = false;
          errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
        } else {
          contentUpdate = dataUpdate.birth_day;
        }
        break;
      case "forget_password":
        contentUpdate = "Cấp lại mật khẩu đăng nhập";
        break;
      case "confirm_account":
        contentUpdate = "Xác minh tài khoản";
        break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };

  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };

  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };

  // chọn phương thức xác thực
  // - files / xác nhận hoàn thành: gửi luôn
  // - email / SĐT: mở popup nhập email / SĐT đã liên kết rồi mới gửi
  const modalConfirmUpdate = async (type) => {
    if (!validateForm()) return;
    if (type === "files" || (type === "auto_confirm" && canAutoConfirm)) {
      updateUser(type);
      return;
    }

    const isEmail = type === "mail";
    const result = await Swal.fire({
      icon: "warning",
      title: isEmail
        ? "Vui lòng nhập Email đã liên kết"
        : "Vui lòng nhập Số Điện Thoại đã liên kết",
      input: isEmail ? "email" : "text",
      inputValue: isEmail ? dataCheck.email : dataCheck.phone_number,
      inputPlaceholder: isEmail ? "Email" : "Số Điện Thoại",
      showCancelButton: true,
      confirmButtonText: "Tiếp tục",
      cancelButtonText: "Quay lại",
      confirmButtonColor: "#F27121",
      reverseButtons: true,
      inputValidator: (value) => {
        const normalizedValue = isEmail
          ? value.trim().toLowerCase()
          : value.trim().replace(/^(\+?84)/, "0");

        if (!normalizedValue) {
          return isEmail
            ? "Vui lòng nhập Email"
            : "Vui lòng nhập Số Điện Thoại";
        }
        if (isEmail && !/\S+@\S+\.\S+/.test(normalizedValue)) {
          return "Email không hợp lệ";
        }
        if (!isEmail && !/^\d{10}$/.test(normalizedValue)) {
          return "Số Điện Thoại không hợp lệ";
        }
        return undefined;
      },
    });

    if (result.isConfirmed) {
      const value = isEmail
        ? result.value.trim().toLowerCase()
        : result.value.trim().replace(/^(\+?84)/, "0");
      const nextDataCheck = {
        ...dataCheck,
        [isEmail ? "email" : "phone_number"]: value,
      };
      setDataCheck(nextDataCheck);
      // truyền nextDataCheck vì setDataCheck chưa cập nhật state ngay
      updateUser(type, nextDataCheck);
    }
  };

  // gửi yêu cầu, nhận mã yêu cầu rồi mở popup theo dõi trạng thái
  const confirmUpdateUser = async (body, type) => {
    setLoading(true)
    let updateInfo = await apiFormUpdateAccount(body, type === "auto_confirm" ? [] : selectedFiles);
    setLoading(false)
    if (updateInfo) {
      const requestCode = updateInfo?.request_code;
      if (!requestCode) {
        return Swal.fire({ icon: "error", text: "Không nhận được mã yêu cầu. Vui lòng thử lại." });
      }
      const newRequest = {
        ...updateInfo,
        request_code: requestCode,
        status: updateInfo.status || "no_process",
        verification_status: updateInfo.verification_status || (["email", "phone_number"].includes(user.send_type) ? "not_received" : "success"),
        send_type: user.send_type,
        update_type: user.update_type,
      };
      setUser((current) => ({ ...current, request_code: requestCode }));
      setSubmittedRequest(newRequest);
      setPollingChecks(0);
      setRequestRefreshMessage("");
      openModalConfirm(type);
    }
  };

  // submit = true: đã tải đủ file ở popup upload, gửi yêu cầu
  const updateUser = async (type, checkData = dataCheck, submit = false) => {
    if (validateForm(type, checkData)) {
      if (type === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      } else if (type === "auto_confirm" && canAutoConfirm) {
        user.send_type = "auto_confirm";
        updateUserField("send_type", "auto_confirm");
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...checkData,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
          // đổi ngân hàng: gửi thêm mã ngân hàng + số tài khoản để BE không phải tách từ content
          ...(user.update_type === "bank" && {
            bank_code: dataUpdate.bank_code,
            bank_number: dataUpdate.bank_number,
          }),
        }
      };
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        if (type === "files" && !submit) {
          let descriptionFileUpload = uploadDescriptions.length > 0
            ? "Bạn vui lòng tải lên ít nhất " + minFiles + " trong " + uploadDescriptions.length + " hình ảnh/video dưới để xác minh tài khoản<br/><br/>"
            : "Bạn vui lòng tải lên ít nhất " + minFiles + " hình ảnh/video để xác minh tài khoản<br/><br/>";
          // danh sách mô tả căn lề trái
          let descriptionList = "";
          uploadDescriptions.forEach((element, index) => {
            descriptionList += (index + 1) + ". " + element + "</br>";
          });
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>" +
            (descriptionList ? "<div style='text-align: left'>" + descriptionList + "</div>" : "");
          setInfoFileUpload(descriptionFileUpload)
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu đã nhập lại nhiều lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        if (timesCheckData >= 100 && checkDataOld.allowSubmit > 0) {
          confirmUpdateUser(body, type);
        } else {
          // email / SĐT xác thực nhập không đúng với thông tin đã liên kết thì cảnh báo
          const verificationError =
            type === "phone_number" && checkDataOld.submitPhoneNumber === 0
              ? "Quý khách nhập không đúng SĐT đã liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác."
              : type === "mail" && checkDataOld.submitEmail === 0
                ? "Quý khách nhập không đúng Email đã liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác."
                : "";
          if (!verificationError) {
            confirmUpdateUser(body, type);
            return;
          }
          setLoading(false)
          Swal.fire({
            icon: "warning",
            title: "Chú ý",
            text: verificationError,
            showCancelButton: true,
            cancelButtonText: 'Nhập lại',
            confirmButtonText: 'Tiếp tục gửi',
            confirmButtonColor: "#F27121",
            showConfirmButton:
              type === "files" ||
              (type === "phone_number" && checkDataOld.submitPhoneNumber === 1) ||
              (type === "mail" && checkDataOld.submitEmail === 1),
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              confirmUpdateUser(body, type);
            } else if (result.isDismissed) {
              setTimesCheckData((currentTimes) => currentTimes + 1);
              if (type === "mail" || type === "phone_number") modalConfirmUpdate(type);
            }
          });
        }
      }
    }
  };

  // đóng popup: đưa yêu cầu vừa gửi lên đầu danh sách yêu cầu gần đây (tối đa 2)
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    const recentRequests = submittedRequest
      ? [submittedRequest, ...(data?.recent_requests || []).filter((item) => item.request_code !== submittedRequest.request_code)].slice(0, 2)
      : (data?.recent_requests || []).slice(0, 2);
    navigate("/profile", { state: { userName, data: { ...data, recent_requests: recentRequests }, webSetting } });
  };

  const handleMediaUpload = async (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter((file) => {
      if (file.size > 3 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `File ${file.name} vượt quá giới hạn 3MB.`,
        });
        return false;
      }
      return true;
    });

    event.target.value = ""; // cho phép chọn lại cùng 1 file sau khi xóa
    if (previews.length + validFiles.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 file",
      });
      return;
    }
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith("image") ? "image" : "video"
    }));
    const base64Images = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Images]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <>
      {loading && <Loading loading={loading} />}
      <motion.div
        initial={{ x: "100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "-100vw", opacity: 0 }}
        transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        className="overflow-x-hidden"
      >
        <div className="w-full max-w-[640px] max-[640px]:max-w-[480px] max-[375px]:max-w-[320px] mx-auto p-0 sm:p-4 md:p-5 rounded-[20px]">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="relative w-full rounded-[20px] md:rounded-[24px] border-[1.5px] border-[#FEF1E9] bg-gradient-to-b from-white to-[#FFEBDD] shadow-[0_0_0_2px_rgba(255,228,207,0.30),0_8px_32px_8px_rgba(242,113,33,0.08),0_4px_16px_4px_rgba(0,0,0,0.04)] tracking-wide flex flex-col justify-start items-center gap-2 !pt-0 p-3 sm:p-4 md:p-5"
          >
            <div className="w-full h-fit flex justify-center items-center">
              <img
                src="/search/title-sup-cskh.png"
                alt="logo"
                className="w-full max-w-[200px] sm:max-w-[250px] md:max-w-[300px] h-auto object-contain"
              />
            </div>

            {/* <p className="w-full text-[#F27121] text-center text-[14px] sm:text-[15px] md:text-[16px] lg:text-[18px] font-bold leading-[24px] sm:leading-[26px] md:leading-[28px] uppercase tracking-wide px-2">
              THÔNG TIN CÁ NHÂN
            </p>

            <div className="w-full rounded-[16px] md:rounded-[20px] border border-[#DCDFE3] bg-[rgba(255,255,255,0.70)] shadow-[-42px_103px_31px_0_rgba(145,145,145,0.00),-27px_66px_29px_0_rgba(145,145,145,0.01),-15px_37px_24px_0_rgba(145,145,145,0.03),-7px_17px_18px_0_rgba(145,145,145,0.04),-2px_4px_10px_0_rgba(145,145,145,0.05)] px-2 sm:px-2.5">
              <InfoUser />
            </div> */}

            <div className="w-full text-left mx-2 sm:mx-3 md:mx-4 mt-3 sm:mt-4">
              <span
                className="block mt-2 sm:mt-2.5 mb-1 tracking-wide text-[#F27121] text-center font-inter text-[13px] sm:text-[14px] md:text-[16px] lg:text-[18px] font-bold leading-[22px] sm:leading-[24px] md:leading-[28px] uppercase px-1"
              >
                VUI LÒNG NHẬP LẠI <br className="sm:hidden"/>THÔNG TIN ĐÃ LIÊN KẾT
              </span>
              <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                <div className="flex flex-col">
                  <input
                    type="text"
                    name="name"
                    value={dataCheck.name}
                    onChange={inputDataCheck}
                    placeholder="Họ Và Tên"
                    className="h-10 sm:h-11 md:h-12 px-3 sm:px-3.5 md:px-4 outline-none bg-white rounded-[6px] sm:rounded-[7px] border border-[#F27121] text-sm sm:text-[15px] md:text-base font-medium text-[#F27121] leading-normal placeholder:text-[#8e8e8e] placeholder:text-xs sm:placeholder:text-sm placeholder:italic focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                  />
                  {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
                </div>
                <div className="flex flex-col">
                  <div className="relative">
                    <select
                      name="bank_code"
                      value={dataCheck.bank_code || ""}
                      onChange={selectBankCheck}
                      className="w-full h-10 sm:h-11 md:h-12 px-3 sm:px-3.5 md:px-4 pr-8 sm:pr-9 md:pr-10 outline-none bg-white rounded-[6px] sm:rounded-[7px] border border-[#F27121] text-sm sm:text-[15px] md:text-base font-medium text-[#F27121] leading-normal appearance-none focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                    >
                      <option value="" className="text-[#8e8e8e] text-sm">Chọn Ngân Hàng</option>
                      {banks.map((bank) => (
                        <option key={bank.code} value={bank.code} className="bg-white text-[#F27121]">
                          {bank.name}
                        </option>
                      ))}
                    </select>
                    {/* mũi tên trỏ xuống: cho khách biết đây là ô chọn */}
                    <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#F27121]">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </span>
                  </div>
                  {errors.bank_name && <p className="text-red-500 text-sm mt-1">{errors.bank_name}</p>}
                </div>
                <div className="flex flex-col">
                  <input
                    type="text"
                    name="bank_number"
                    value={dataCheck.bank_number}
                    onChange={inputDataCheck}
                    placeholder="Số Tài Khoản"
                    className="h-12 px-4 outline-none bg-white rounded-[7px] border border-[#F27121] text-base font-medium text-[#F27121] leading-normal placeholder:text-[#8e8e8e] placeholder:text-sm placeholder:italic focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                  />
                  {errors.bank_number && <p className="text-red-500 text-sm mt-1">{errors.bank_number}</p>}
                </div>
              </div>
            </div>

            <div className="w-full text-left mx-2 sm:mx-3 md:mx-4 mt-2 sm:mt-2.5">
              {
                {
                  "full_name":
                    <>
                      <span className="block mt-2 sm:mt-2.5 mb-1 tracking-wide text-[#F27121] text-center font-inter text-[13px] sm:text-[14px] md:text-[16px] lg:text-[18px] font-bold leading-[22px] sm:leading-[24px] md:leading-[28px] uppercase px-1">
                        THAY ĐỔI HỌ TÊN MỚI
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <input
                            type="text"
                            name="name"
                            onChange={inputDataUpdate}
                            placeholder="Họ Tên Mới"
                            className="h-12 px-4 outline-none bg-white rounded-[7px] border border-[#F27121] text-base font-medium text-[#F27121] leading-normal placeholder:text-[#8e8e8e] placeholder:text-sm placeholder:italic focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                          />
                          {errors.nameUpdate && <p className="text-red-500 text-sm mt-1">{errors.nameUpdate}</p>}
                        </div>
                      </div>
                    </>,
                  "phone_number":
                    <>
                      <span className="block text-[13px] sm:text-[14px] md:text-[15px] font-[550] text-[#F27121] font-['Roboto',sans-serif] text-center mt-2 sm:mt-2.5 mb-2 sm:mb-3 px-1">
                        THAY ĐỔI SỐ ĐIỆN THOẠI MỚI
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <input
                            type="text"
                            name="phone_number"
                            onChange={inputDataUpdate}
                            placeholder="Số Điện Thoại Mới"
                            className="h-12 px-4 outline-none bg-white rounded-[7px] border border-[#F27121] text-base font-medium text-[#F27121] leading-normal placeholder:text-[#8e8e8e] placeholder:text-sm placeholder:italic focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                          />
                          {errors.phoneNumberUpdate && <p className="text-red-500 text-sm mt-1">{errors.phoneNumberUpdate}</p>}
                        </div>
                      </div>
                    </>,
                  "email":
                    <>
                      <span className="block text-[13px] sm:text-[14px] md:text-[15px] font-[550] text-[#F27121] font-['Roboto',sans-serif] text-center mt-2 sm:mt-2.5 mb-2 sm:mb-3 px-1">
                        THAY ĐỔI EMAIL MỚI
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <input
                            type="text"
                            name="email"
                            onChange={inputDataUpdate}
                            placeholder="Email Mới"
                            className="h-12 px-4 outline-none bg-white rounded-[7px] border border-[#F27121] text-base font-medium text-[#F27121] leading-normal placeholder:text-[#8e8e8e] placeholder:text-sm placeholder:italic focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                          />
                          {errors.emailUpdate && <p className="text-red-500 text-sm mt-1">{errors.emailUpdate}</p>}
                        </div>
                      </div>
                    </>,
                  "bank":
                    <>
                      <span className="block text-[13px] sm:text-[14px] md:text-[15px] font-[550] text-[#F27121] font-['Roboto',sans-serif] text-center mt-2 sm:mt-2.5 mb-2 sm:mb-3 px-1">
                        {desChangeBank.title_change_bank}
                      </span>
                      <div className="flex flex-col w-full mx-auto gap-2 sm:gap-2.5 md:gap-3">
                        <div className="flex flex-col">
                          <div className="relative">
                            <select
                              type="input"
                              name="bank_type_change"
                              onChange={inputDataUpdate}
                              className="w-full h-12 px-4 pr-10 outline-none bg-white rounded-[7px] border border-[#F27121] text-base font-medium text-[#F27121] leading-normal appearance-none focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                            >
                              <option value="" className="text-[#8e8e8e] text-sm">Chọn yêu cầu thay đổi</option>
                              {config.LIST_REQUEST_BANK.map((bank, index) => (
                                <option key={index} value={bank} className="bg-white text-[#F27121]">
                                  {bank}
                                </option>
                              ))}
                            </select>
                            {/* mũi tên trỏ xuống: cho khách biết đây là ô chọn */}
                            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#F27121]">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="6 9 12 15 18 9" />
                              </svg>
                            </span>
                          </div>
                          {errors.bankTypeChange && <p className="text-red-500 text-sm mt-1">{errors.bankTypeChange}</p>}
                        </div>
                        <div className="flex flex-col">
                          <div className="relative">
                            <select
                              name="bank_code"
                              value={dataUpdate.bank_code || ""}
                              onChange={selectBankUpdate}
                              className="w-full h-12 px-4 pr-10 outline-none bg-white rounded-[7px] border border-[#F27121] text-base font-medium text-[#F27121] leading-normal appearance-none focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                            >
                              <option value="" className="text-[#8e8e8e] text-sm">{`Chọn ${desChangeBank.bank_name.replace("Tên ", "")}`}</option>
                              {banks.map((bank) => (
                                <option key={bank.code} value={bank.code} className="bg-white text-[#F27121]">
                                  {bank.name}
                                </option>
                              ))}
                            </select>
                            {/* mũi tên trỏ xuống: cho khách biết đây là ô chọn */}
                            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#F27121]">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="6 9 12 15 18 9" />
                              </svg>
                            </span>
                          </div>
                          {errors.bankNameUpdate && <p className="text-red-500 text-sm mt-1">{errors.bankNameUpdate}</p>}
                        </div>
                        <div className="flex flex-col">
                          <input
                            type="text"
                            name="bank_number"
                            onChange={inputDataUpdate}
                            placeholder={desChangeBank.bank_number}
                            className="h-12 px-4 outline-none bg-white rounded-[7px] border border-[#F27121] text-base font-medium text-[#F27121] leading-normal placeholder:text-[#8e8e8e] placeholder:text-sm placeholder:italic focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                          />
                          {errors.bankNumberUpdate && <p className="text-red-500 text-sm mt-1">{errors.bankNumberUpdate}</p>}
                        </div>
                      </div>
                    </>,
                  "birthday":
                    <div className="flex flex-col w-full mx-auto gap-3">
                      <div className="flex flex-col">
                        <input
                          type="date"
                          name="birth_day"
                          onChange={inputDataUpdate}
                          placeholder="ngày tháng năm sinh"
                          defaultValue="2000-12-01"
                          className="h-12 px-4 outline-none bg-white rounded-[7px] border border-[#F27121] text-base font-medium text-[#F27121] leading-normal focus:border-[#f58d4d] focus:ring-1 focus:ring-[#F27121] transition-all"
                        />
                        {errors.birthDayUpdate && <p className="text-red-500 text-sm mt-1">{errors.birthDayUpdate}</p>}
                      </div>
                    </div>,
                }[typeModal]
              }
            </div>
            <div className="w-[95%] sm:w-[90%] mx-2 sm:mx-3 md:mx-4 mb-3 sm:mb-4 mt-2 sm:mt-2.5 text-left">
              <span className="block mt-2 sm:mt-2.5 mb-1 tracking-wide text-[#F27121] text-center font-inter text-[13px] sm:text-[14px] md:text-[16px] lg:text-[18px] font-bold uppercase leading-[20px] sm:leading-[22px] md:leading-[24px] px-1">
                VUI LÒNG LỰA CHỌN <br className="sm:hidden"/>HÌNH THỨC GỬI XÁC THỰC
              </span>
              {canAutoConfirm && (
                <div className="flex justify-center items-center mt-2 sm:mt-2.5">
                  <button
                    type="button"
                    onClick={() => modalConfirmUpdate("auto_confirm")}
                    disabled={loading}
                    className="cursor-pointer rounded-[20px] sm:rounded-[25px] min-w-[180px] h-[38px] sm:h-[42px] px-5 text-white text-xs sm:text-sm font-semibold bg-gradient-to-r from-[#ff9f4d] to-[#F27121] shadow-[0px_2px_8px_rgba(242,113,33,0.35)] border border-[#F27121] hover:shadow-[0px_4px_12px_rgba(242,113,33,0.50)] hover:scale-105 transition-all duration-200 disabled:opacity-60"
                  >
                    XÁC NHẬN HOÀN THÀNH
                  </button>
                </div>
              )}
              {(typeModal !== "birthday") &&
                <>
                  {/* xác minh tài khoản: chỉ xác thực bằng hình ảnh / video, không có email / SĐT */}
                  {typeModal !== "confirm_account" && <>
                  <div className="flex gap-2 sm:gap-3 md:gap-4 justify-center items-center h-9 sm:h-10 mt-2 sm:mt-2.5">
                    {data.email &&
                      <button
                        onClick={() => modalConfirmUpdate("mail")}
                        className="cursor-pointer inline-flex items-center justify-center max-w-[47%] [&>img]:object-contain [&>img:hover]:scale-[1.02] [&>img:hover]:transition-transform [&>img:hover]:duration-200 [&>img:active]:scale-95"
                      >
                        <img src="/button/bt-sub-email.png" alt="img-sub-email" />
                      </button>
                    }
                    {data.phone_number &&
                      <button
                        onClick={() => modalConfirmUpdate("phone_number")}
                        className="cursor-pointer inline-flex items-center justify-center max-w-[47%] [&>img]:object-contain [&>img:hover]:scale-[1.02] [&>img:hover]:transition-transform [&>img:hover]:duration-200 [&>img:active]:scale-95"
                      >
                        <img src="/button/bt-sub-phone.png" alt="img-sub-phone" />
                      </button>
                    }
                  </div>
                  <p className="text-[12px] sm:text-[13px] text-[#2F3945] text-center italic mt-3 mb-2 px-2">
                    Nếu quý khách không có email hoặc SĐT để gửi thông tin, vui lòng nhấn nút dưới đây để thực hiện thay thế
                  </p>
                  </>}
                  <div className="flex justify-center items-center">
                    <button
                      type="button"
                      onClick={() => modalConfirmUpdate("files")}
                      disabled={loading}
                      className="cursor-pointer inline-flex items-center justify-center gap-2 rounded-[20px] sm:rounded-[25px] min-w-[200px] h-[38px] sm:h-[42px] px-5 text-white text-xs sm:text-sm font-semibold bg-gradient-to-r from-[#ff9f4d] to-[#F27121] shadow-[0px_2px_8px_rgba(242,113,33,0.35)] border border-[#F27121] hover:shadow-[0px_4px_12px_rgba(242,113,33,0.50)] hover:scale-105 transition-all duration-200 disabled:opacity-60"
                    >
                      <img src="/icons/icon-send-image.png" alt="icon-send-image" className="w-4 h-4 sm:w-5 sm:h-5 object-contain brightness-0 invert" />
                      XÁC THỰC HÌNH ẢNH / VIDEO
                    </button>
                  </div>
                </>
              }
            </div>
          </motion.div>
        </div>

        {/* Modal Confirm */}
        <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested>
          <motion.div
            initial={{ opacity: 0, y: 75 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white max-w-[480px] max-[640px]:max-w-[95%] max-[375px]:max-w-[98%] w-[96%] rounded-lg sm:rounded-xl mx-auto relative border border-[#E5E5E5] shadow-[0_4px_20px_rgba(0,0,0,0.15)]"
          >
            {/* Close button: cách duy nhất để đóng popup cuối, cùng kiểu với các popup khác */}
            <div className="absolute top-2 sm:top-3 right-2 sm:right-3 z-[99]">
              <button
                className="flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-[radial-gradient(100%_100%_at_50%_0%,rgba(255,255,255,0.4)_0%,rgba(255,255,255,0)_100%),linear-gradient(180deg,#ff9f4d_0%,#f27121_100%)] shadow-[0px_4px_12px_rgba(242,113,33,0.45)] border-none cursor-pointer p-0 hover:scale-110 transition-transform"
                onClick={closeModalConfirm}
                aria-label="Đóng"
              >
                <img src="/icons/icon-close.png" alt="icon-close" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
              </button>
            </div>

            {/* Popup cuối: dùng chung cho mọi kiểu xác thực (email, SĐT, hình ảnh, xác nhận hoàn thành) */}
            <div className="flex flex-col items-start p-4 sm:p-5 pt-6 sm:pt-7 max-h-[90vh] overflow-y-auto">
              {/* Instruction Text */}
              {isSendMail ? (
                <p className="text-sm sm:text-[15px] font-medium mb-3 text-[#2F3945] leading-relaxed text-left w-full m-0">
                  Vui lòng sử dụng gmail đã liên kết <span className="text-[#F27121] font-semibold">{dataCheck.email}</span>, gửi tin nhắn tới email SC88{" "}
                  <span className="text-[#F27121] font-semibold">{webSetting.email}</span>, với nội dung:
                </p>
              ) : user.send_type === 'phone_number' ? (
                <p className="text-sm sm:text-[15px] font-medium mb-3 text-[#2F3945] leading-relaxed text-left w-full m-0">
                  Vui lòng sử dụng số điện thoại đã liên kết <span className="text-[#F27121] font-semibold">{dataCheck.phone_number}</span>, gửi tin nhắn tới số điện thoại SC88{" "}
                  <span className="text-[#F27121] font-semibold">{webSetting.phone_number}</span>, với nội dung:
                </p>
              ) : (
                <p className="text-sm sm:text-[15px] font-medium mb-3 text-[#2F3945] leading-relaxed text-left w-full m-0">
                  SC88 đã ghi nhận yêu cầu của quý khách. Vui lòng đợi xét duyệt.
                </p>
              )}

              {/* Data Confirm Content: loại yêu cầu, tên đăng nhập, mã yêu cầu */}
              <div className="w-full mb-3">
                <DataConfirm user={user} webSetting={webSetting} />
              </div>

              {/* Trạng thái xử lý + tiến trình */}
              {submittedRequest && (() => {
                const needVerify = ["email", "phone_number"].includes(submittedRequest.send_type);
                const verifySuccess = !needVerify || submittedRequest.verification_status === "success";
                const isPolling = submittedRequest.status === "no_process" && pollingChecks < 15;
                // màu bước: hoàn thành xanh, lỗi đỏ, đang thực hiện màu thương hiệu, đang chờ cam, chưa tới xám
                const STEP_CLASS = {
                  complete: "bg-green-500 text-white border-green-500",
                  error: "bg-red-500 text-white border-red-500",
                  current: "bg-[#F27121] text-white border-[#F27121]",
                  waiting: "bg-orange-100 text-orange-600 border-orange-400",
                  pending: "bg-gray-100 text-gray-400 border-gray-300",
                };
                const steps = [
                  { label: "Đã gửi yêu cầu", state: "complete" },
                  {
                    label: needVerify ? "Xác thực" : "Đã tiếp nhận",
                    state: verifySuccess ? "complete" : submittedRequest.verification_status === "invalid" ? "error" : "waiting",
                  },
                  {
                    label: "Đang xử lý",
                    state: submittedRequest.status === "approved" ? "complete"
                      : submittedRequest.status === "removed" ? "error"
                        : !verifySuccess ? "pending" : "current",
                  },
                  {
                    label: "Hoàn tất",
                    state: submittedRequest.status === "approved" ? "complete" : submittedRequest.status === "removed" ? "error" : "pending",
                  },
                ];
                const title = submittedRequest.status === "approved" ? "Yêu cầu đã xử lý thành công"
                  : submittedRequest.status === "removed" ? "Yêu cầu đã bị từ chối"
                    : !verifySuccess ? "Yêu cầu đang chờ xác thực"
                      : pollingChecks < 15 ? "Yêu cầu đang được xử lý" : "Yêu cầu đang được xử lý lâu hơn dự kiến";
                const titleClass = submittedRequest.status === "approved" ? "text-green-700"
                  : submittedRequest.status === "removed" ? "text-red-600"
                    : !verifySuccess ? "text-orange-600" : "text-[#F27121]";
                return (
                  <div className="w-full rounded-[10px] border border-[#FEF1E9] bg-[#FFF8F3] p-3 flex flex-col gap-2">
                    {submittedRequest.status === "no_process" && (
                      <div className="flex items-center gap-2" role="status" aria-live="polite">
                        {isPolling
                          ? <span className="w-4 h-4 shrink-0 rounded-full border-2 border-[#F27121] border-t-transparent animate-spin" aria-hidden="true" />
                          : <span className="w-4 h-4 shrink-0 rounded-full bg-green-500 text-white text-[10px] leading-4 text-center" aria-hidden="true">✓</span>}
                        <div className="flex flex-col">
                          <strong className="text-[12px] sm:text-[13px] text-[#2F3945]">{isPolling ? "Hệ thống đang tự động cập nhật trạng thái" : "Đã hoàn tất kiểm tra tự động"}</strong>
                          <small className="text-[11px] sm:text-[12px] text-[#6b7280]">{isPolling ? "Vui lòng giữ màn hình này mở và chờ kết quả xử lý." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
                        </div>
                      </div>
                    )}
                    <h3 className={`text-[14px] sm:text-[15px] font-bold m-0 ${titleClass}`}>{title}</h3>
                    {(submittedRequest.note || submittedRequest.result) && (
                      <div className="text-[13px] text-[#2F3945]"><strong>Kết quả xử lý:</strong><HtmlNote html={submittedRequest.note || submittedRequest.result} /></div>
                    )}
                    <div className="grid grid-cols-4 gap-1">
                      {steps.map((step, index) => (
                        <div key={step.label} className="flex flex-col items-center gap-1 text-center">
                          <span className={`w-6 h-6 rounded-full border text-[12px] font-bold leading-[22px] ${STEP_CLASS[step.state]}`}>{index + 1}</span>
                          <small className="text-[10px] sm:text-[11px] text-[#2F3945] leading-tight">{step.label}</small>
                        </div>
                      ))}
                    </div>
                    {submittedRequest.status === "no_process" && (
                      <div className="text-[12px] sm:text-[13px]">
                        {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p className="m-0 text-orange-600">Chưa nhận xác thực. Vui lòng gửi từ email đã liên kết.</p>}
                        {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p className="m-0 text-orange-600">Chưa nhận xác thực. Vui lòng gửi từ số điện thoại đã liên kết.</p>}
                        {submittedRequest.verification_status === "invalid" && <p className="m-0 text-red-600">Xác thực không hợp lệ. Vui lòng kiểm tra thông tin và gửi lại.</p>}
                      </div>
                    )}
                    {pollingChecks >= 15 && submittedRequest.status === "no_process" && (
                      <div className="flex flex-wrap justify-center gap-2">
                        <button
                          type="button"
                          disabled={isRefreshingRequest}
                          onClick={refreshSubmittedRequest}
                          className="h-8 px-3 rounded-[16px] text-white text-xs font-semibold bg-gradient-to-r from-[#ff9f4d] to-[#F27121] border-none cursor-pointer hover:shadow-[0px_4px_12px_rgba(242,113,33,0.50)] disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                          {isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}
                        </button>
                        <button
                          type="button"
                          onClick={copySubmittedRequestCode}
                          className="h-8 px-3 rounded-[16px] text-[#F27121] text-xs font-semibold bg-white border border-[#F27121] cursor-pointer hover:bg-[#FFF5ED]"
                        >
                          Sao chép mã
                        </button>
                        <a
                          href={webSetting.link_cskh}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="h-8 px-3 inline-flex items-center rounded-[16px] text-[#F27121] text-xs font-semibold bg-white border border-[#F27121] no-underline hover:bg-[#FFF5ED]"
                        >
                          Liên hệ CSKH
                        </a>
                      </div>
                    )}
                    {requestRefreshMessage && <p className="m-0 text-[12px] text-[#2F3945]" role="status">{requestRefreshMessage}</p>}
                  </div>
                );
              })()}

              {/* Lưu ý: đóng popup bằng nút × ở góc trên */}
              <div className="w-full bg-gradient-to-br from-[#FFF5ED] to-[#FFEBDD] border border-[#FEF1E9] rounded-[8px] sm:rounded-[10px] px-3 py-2 mt-3 text-[12px] sm:text-[13px] text-[#2F3945] text-left">
                <p className="text-[#F27121] font-bold m-0 mb-1">Lưu ý:</p>
                <p className="m-0 leading-relaxed">
                  - Liên hệ{" "}
                  <a href={webSetting.link_cskh} target="_blank" rel="noopener noreferrer" className="text-[#F27121] font-semibold no-underline hover:underline">CSKH</a>{" "}
                  nếu cần hỗ trợ thêm.
                </p>
              </div>
            </div>
          </motion.div>
        </Popup>
        {/* Modal Result */}
        <Popup open={openResult} onClose={() => setOpenResult(false)} position={"center"}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-gradient-to-b from-white to-[#FFF5ED] max-w-[400px] max-[640px]:max-w-[95%] max-[375px]:max-w-[98%] w-[96%] rounded-lg sm:rounded-xl mx-auto relative py-4 sm:py-5 md:py-6 px-3 sm:px-4 border-[1.5px] border-[#FEF1E9] shadow-[0_0_0_2px_rgba(255,228,207,0.30),0_8px_32px_8px_rgba(242,113,33,0.08),0_4px_16px_4px_rgba(0,0,0,0.04)]"
          >
            <div className="absolute top-2 sm:top-3 right-2 sm:right-3 z-[99]">
              <button
                className="flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-[radial-gradient(100%_100%_at_50%_0%,rgba(255,255,255,0.4)_0%,rgba(255,255,255,0)_100%),linear-gradient(180deg,#ff9f4d_0%,#f27121_100%)] shadow-[0px_4px_12px_rgba(242,113,33,0.45)] border-none cursor-pointer p-0 hover:scale-110 transition-transform"
                onClick={() => setOpenResult(false)}
              >
                <img src="/icons/icon-close.png" alt="icon-close" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
              </button>
            </div>
            {checkConfirm ? (
              <div className="flex items-center flex-col justify-center text-center pt-2">
                <img className="mb-4 sm:mb-5 md:mb-6 w-16 h-16 sm:w-[72px] sm:h-[72px] md:w-20 md:h-20 object-contain" src="/icons/icon-success.png" alt="icon-success" />
                <span className="px-2 sm:px-3 pb-2 text-[13px] sm:text-[14px] md:text-[15px] lg:text-base font-semibold text-[#2F3945] leading-relaxed">Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ 2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ</span>
              </div>
            ) : (
              <div className="flex items-center flex-col justify-center text-center pt-2">
                <img className="mb-4 sm:mb-5 md:mb-6 w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 object-contain" src="/icons/icon-warning.png" alt="icon-warning" />
                <span className="px-2 sm:px-3 pb-2 text-[13px] sm:text-[14px] md:text-[15px] lg:text-base font-semibold text-[#2F3945] leading-relaxed">Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc liên hệ chăm sóc khách hàng</span>
              </div>
            )}
          </motion.div>
        </Popup>
        {/* Modal Upload File */}
        <Popup open={openUploadFile} onClose={() => setOpenUploadFile(false)} position={"center"}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-gradient-to-b from-white to-[#FFF5ED] max-w-[400px] max-[640px]:max-w-[95%] max-[375px]:max-w-[98%] w-[96%] rounded-lg sm:rounded-xl mx-auto relative py-4 sm:py-5 md:py-6 px-3 sm:px-4 border-[1.5px] border-[#FEF1E9] shadow-[0_0_0_2px_rgba(255,228,207,0.30),0_8px_32px_8px_rgba(242,113,33,0.08),0_4px_16px_4px_rgba(0,0,0,0.04)]"
          >
            <div className="absolute top-2 sm:top-3 right-2 sm:right-3 z-[99]">
              <button
                className="flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-[radial-gradient(100%_100%_at_50%_0%,rgba(255,255,255,0.4)_0%,rgba(255,255,255,0)_100%),linear-gradient(180deg,#ff9f4d_0%,#f27121_100%)] shadow-[0px_4px_12px_rgba(242,113,33,0.45)] border-none cursor-pointer p-0 hover:scale-110 transition-transform"
                onClick={() => setOpenUploadFile(false)}
              >
                <img src="/icons/icon-close.png" alt="icon-close" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
              </button>
            </div>
            <div className="flex items-center flex-col justify-center text-center pt-2">
              <img className="mb-4 sm:mb-5 w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 object-contain" src="/icons/icon-warning.png" alt="icon-warning" />

              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  color: "black",
                  marginBottom: "-10px",
                  marginTop: "-15px",
                  fontWeight: "bold",
                }}
              >
                <div className='upload-file' dangerouslySetInnerHTML={{ __html: infoFileUpload }} />
              </Typography>
              <Box
                display="flex"
                alignItems="center"
                marginY={1}
                flexWrap="wrap"
                gap="8px 8px"
              >
                {previews.map((preview, index) => (

                  <Box
                    onClick={() => handleRemoveImage(index)}
                    key={index}
                    sx={{
                      maxHeight: 85,
                      maxWidth: 95,
                      width: "auto",
                      height: "auto",
                      position: "relative",
                      overflow: "hidden",
                      cursor: "pointer",
                      borderRadius: "8px",
                      "&:hover .delete-button": {
                        display: "block",
                      },
                    }}
                  >
                    {preview.type === "image" ? (
                      <img
                        src={preview.url}
                        alt={`preview-${index}`}
                        style={{
                          width: "auto",
                          maxWidth: "100%",
                          height: "auto",
                          maxHeight: "100%",
                          borderRadius: 4,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <video
                        src={preview.url}
                        controls
                        style={{
                          width: "auto",
                          maxWidth: "100%",
                          height: "auto",
                          maxHeight: "100%",
                          borderRadius: 4,
                          objectFit: "cover",
                        }}
                      />
                    )}
                    <IconButton
                      className="delete-button"
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        color: "red",
                        p: 0,
                      }}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </Box>
                ))}

                <Box>
                  <input
                    accept="image/*, video/*"
                    style={{ display: "none" }}
                    id="upload-button"
                    type="file"
                    onChange={handleMediaUpload}
                    multiple
                  />
                  <label htmlFor="upload-button">
                    <Button
                      variant="outlined"
                      component="span"
                      startIcon={
                        <AddPhotoAlternateOutlined
                          sx={{ fontSize: "large" }}
                        />
                      }
                      sx={{
                        width: "85px",
                        height: "75px",
                        color: "#F27121",
                        borderColor: "#F27121",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        fontSize: "0.875rem",
                        "&:hover": {
                          borderColor: "#f58d4d",
                          color: "#f58d4d",
                          backgroundColor: "rgba(242, 113, 33, 0.05)",
                        },
                      }}
                    >
                      Thêm
                    </Button>
                  </label>
                </Box>
              </Box>
              <Typography variant="caption" sx={{ color: "#8e8e8e", fontSize: "0.75rem", marginTop: "12px", lineHeight: "1.5" }}>
                Cung cấp hình ảnh/video đúng theo mô tả để được xét duyệt <br /> (Hình ảnh/video không được vượt quá 3MB)
              </Typography>
              {selectedImage.length >= minFiles && (
                <div className="mt-4 sm:mt-5">
                  <button
                    id="complete_files_btn"
                    onClick={() => { setOpenUploadFile(false); updateUser(user.send_type, dataCheck, true) }}
                    className="cursor-pointer rounded-[20px] sm:rounded-[25px] w-[150px] sm:w-[170px] h-[38px] sm:h-[42px] text-white text-xs sm:text-sm font-semibold bg-gradient-to-r from-[#ff9f4d] to-[#F27121] shadow-[0px_2px_8px_rgba(242,113,33,0.35)] border border-[#F27121] hover:shadow-[0px_4px_12px_rgba(242,113,33,0.50)] hover:scale-105 transition-all duration-200"
                  >
                    Hoàn thành xác minh
                  </button>
                </div>
              )}
            </div>
          </motion.div>
        </Popup>
      </motion.div>
    </>
  );
}

export default ChangeInfo;
